// extracted by css-extract-rspack-plugin
export default {"BaseSettingsPage":"archive-page-module__BaseSettingsPage__QwIDnDH"};